import React from "react";
import RemovableProjectCode from "components/Removables/RemovableProjectCode";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import ProjectCodeList from "./ProjectCodeList";
import { ModalPickerProps } from "../props";
import NewBusinessCentralProjectModalContent from "BusinessCentral/NewBusinessCentralProjectModalContent";
import Modal from "components/modal";


const ProjectCodeModalPicker = (props: ModalPickerProps<string>) => {
  const [displayBusinessCentralProjectModal, setDisplayBusinessCentralProjectModal] = React.useState(false);
  const onChange = (value: string) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  return <>
    <ModalPickerWithChooseButton
      onNewClicked={() => setDisplayBusinessCentralProjectModal(true)}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Show.ProjectCodes}
      modalSize="tiny"
      renderModalContent={(closeModal) => <ProjectCodeList
        onItemSelected={(projectCode) => {
          closeModal();
          onChange(projectCode.number);
        }}
      />}
      renderRemovable={RemovableProjectCode}
      {...props}
    />
    <Modal
      title={RESX.GeneralLabels.resxNew}
      isOpen={displayBusinessCentralProjectModal}
      handleClose={() => { setDisplayBusinessCentralProjectModal(false); }}
      width="tiny"
    >
      <NewBusinessCentralProjectModalContent
        onSaved={(code) => {
          setDisplayBusinessCentralProjectModal(false);
          onChange(code);
        }}
      />
    </Modal >
  </>
};

export default ProjectCodeModalPicker;